import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const tabs = [
    { id: 'Cashless', label: 'Cashless' },
    { id: 'Reimbursement', label: 'Reimbursement' },
    { id: 'Basisofassessmentofclaims', label: 'Basis of assessment of claims' },
    { id: 'claim-form', label: 'Claim-Form' }
];

const ClaimProcedures = () => {
    const [activeTab, setActiveTab] = useState('Cashless');

    return (
        <div className="page-wrapper">
            <div className="content mb-3">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Claim Procedures</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Claim Procedures
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                <div className="card">
                    <div className="card-body p-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="d-flex align-items-center flex-wrap row-gap-3 justify-content-center w-100">
                                <div style={{ overflowX: 'auto', width: '100%' }}
                                >
                                    <ul className="nav nav-tabs justify-content-center" style={{ minWidth: 'max-content', overflowY: "hidden" }}>
                                        {tabs.map((tab) => (
                                            <li className="nav-item" key={tab.id}>
                                                <button
                                                    className={`nav-link mb-1 ${activeTab === tab.id ? 'active' : ''}`}
                                                    style={{
                                                        backgroundColor: activeTab === tab.id ? '#2e3294' : 'transparent',
                                                        color: activeTab === tab.id ? '#fff' : '#2e3294',
                                                        whiteSpace: 'nowrap', // Prevents text wrapping
                                                        border: "1px solid #2e3294"
                                                    }}
                                                    onClick={() => setActiveTab(tab.id)}
                                                >
                                                    {tab.label}
                                                </button>

                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tab-content p-3 border rounded bg-white">
                    {activeTab === 'Cashless' && (
                        <div>
                            <h3>For Cashless Settlement</h3 >
                            <p>Cashless treatment is only available at a Network Provider (List of Network Providers is available at our website - <Link to='https://www.icicilombard.com/cashless-hospitals' target='"_blank' style={{ color: "orange" }}>Cashless Network Hospital List in India 2022 (icicilombard.com)).</Link> </p>
                            <p>In order to avail of cashless treatment, the following procedure must be followed by the insured:</p>
                            <h5>Pre-authorization</h5>
                            <p>Prior to taking treatment and/or incurring Medical Expenses at a Network Provider, the insured must contact the company or the TPA accompanied with full particulars namely,</p>
                            <ul style={{ paddingLeft: '20px', listStyleType: 'upper-roman' }}>
                                <li>Policy Number,</li>
                                <li>Name of the insured,</li>
                                <li>Your relationship with Policy Holder,</li>
                                <li>Nature of Illness or Injury, name and</li>
                                <li>address of the Medical Practitioner/Hospital and any other information that may be relevant to the Illness/ Injury/ Hospitalization.
                                    Request for pre- authorisation should be received at least 48 hours before a planned Hospitalization and in case of an emergency situation, within 24 hours of Hospitalization. To avail of Cashless Hospitalization facility, the insured is required to produce the health card, as provided to him/her with this Policy, subject to the terms and conditions for the usage of the said health card. The request of insured shall be considered after having obtained accurate and complete information for the Illness or Injury for which cashless hospitalization facility is sought by the insured and the Company will confirm the request in writing.</li>
                            </ul>
                        </div>
                    )}
                    {activeTab === 'Reimbursement' && (
                        <div>
                            <h4 className='mb-3'>For Reimbursement Settlement    </h4>
                            <p>All claims have to be intimated 48 hours prior to hospitalization or within 24 hours post admission in case of emergency for prompt settlement of claims.
                                <p>The insured shall give notice to the TPA by calling the toll free number as specified in the Policy provided to the insured and also in writing at the Company's address with particulars as below:</p>                            </p>
                            <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
                                <li>Policy number;</li>
                                <li>Name of the insured;</li>
                                <li>Relationship of the proposer with the Policyholder;</li>
                                <li>Nature of Illness or Injury;</li>
                                <li>Name and address of the attending Medical Practitioner and the Hospital;</li>
                                <li>Any other information that may be relevant to the Illness / Injury/Hospitalization</li>
                            </ul>
                            <p>The procedure for lodging the claim shall be as under:</p>
                            <p>Upon the happening of any event giving rise or likely to give rise to a claim under this policy:</p>
                            <ul style={{ paddingLeft: '20px', listStyleType: 'lower-alpha' }}>
                                <li>The Insured shall give immediate notice thereof in writing to the Company.</li>
                                <li>The Insured shall deliver to the Company, within 30 days from the date of completion of treatment, a detailed statement in writing as per the claim form together with bills, vouchers and any other material particular, relevant to the making of such claim.</li>
                                <li>The Insured shall tender to the Company all reasonable information, assistance and proofs in connection with any claim hereunder.</li>
                            </ul>
                        </div>
                    )}

                    {activeTab === 'Basisofassessmentofclaims' && (
                        <div>
                            <h4 className='mb-3'>Basis of assessment of claims   </h4>
                            <p><strong>a) Basis of assessment of the claim shall be as under:</strong></p>
                            <p>The benefit payable shall be such expenses reasonably and necessarily incurred by or on behalf of the Insured Person under the following categories but not exceeding the Sum Insured in respect of such Insured person.</p>
                            <p><strong>Heads of compensation payable:</strong></p>
                            <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
                                <li>Room and Boarding Expenses as incurred at the Hospital/ Nursing Home;</li>
                                <li>Nursing Expenses;</li>
                                <li>Fee paid to Medical Practitioner, Surgeon, Anaesthetics, Consultants and Specialist</li>
                                <li>Anaesthesia, Blood, Oxygen, Operation Theatre Charges, Surgical Appliances, Medicines & drugs, Diagnostic Materials and X - Ray, Dialysis, chemotherapy, Radiotherapy, Cost of Pacemaker, Artificial Limbs & Cost of Organs and similar expenses; and /or</li>
                                <li>Pre Hospitalization and Post Hospitalization expenses, wherever applicable.</li>

                            </ul>
                            <p className='mt-3'><strong>b) Claim documents:</strong></p>
                            <p>The Insured shall be required to furnish the following for or in support of a claim:</p>
                            <ul style={{ paddingLeft: '20px', listStyleType: 'lower-alpha' }}>
                                <li>Duly completed claim form signed by the insured.</li>
                                <li>Original bills, receipts and discharge certificate/card from the Hospital</li>
                                <li>Original bills from Chemists supported by proper prescription.</li>
                                <li>Original investigation test reports and payment receipts</li>
                                <li>Indoor case papers</li>
                                <li>Medical Practitioner's referral letter advising Hospitalization in non-Accident cases.</li>
                                <li>Account details for Electronic Fund Transfer (EFT mandate form and cancelled cheque)</li>
                                <li>Any other document as required by the Company or the TPA to investigate the Claim or the Company's obligation to make payment for it.</li>
                            </ul>
                        </div>
                    )}

                    {activeTab === 'claim-form' && (
                        <div className="p-5 d-flex justify-content-center align-items-center h-full">
                            <button className='btn btn-danger'>Download Claim Form</button>
                        </div>
                    )}


                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default ClaimProcedures;
